import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const Footer = () => (
  <footer className="footer">
    <Container fluid>
      <Row className="text-muted">
        <Col xs="6" className="text-left">
          <ul className="list-inline">
            <li className="list-inline-item">
              <a className="text-muted" href="https://www.parousya.com/contact" target="__blank">
                Support
              </a>
            </li>
            <li className="list-inline-item">
              <a className="text-muted" href="https://www.parousya.com/terms" target="__blank">
                Terms &amp; Privacy
              </a>
            </li>
          </ul>
        </Col>
        <Col xs="6" className="text-right">
          <p className="mb-0">
            &copy; {new Date().getFullYear()} -{' '}
            <a href="https://www.parousya.com/" target="__blank" className="text-muted">
              Parousya
            </a>
          </p>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;
